/**
 * EXCEPCIÓN TEMPORAL (2026-10-05): orden por la columna "Estado" oculto en Gestión de ventas,
 * Transferencias, Solicitudes, Registro de inventario y Catálogo de productos. Esas pantallas ya
 * filtran por estado; se espera la próxima ventana con el cliente.
 * - Si el cliente lo pide: poner `true` (el backend todavía ordena por `status`).
 * - Si no lo pide: borrar esta constante, `sortField: 'status'` y `sortable` de esas 5 columnas, `'status'`
 *   de sus listas de campos ordenables aquí y en el backend, y el orden por `status` del backend
 *   (`src/common/list-sort/*-list-sort.ts`, marcado con el mismo comentario).
 */
export const STATUS_COLUMN_SORTABLE = false;
